import SEOLink from '@Components/Listings/SEOLink';
import { BaseTypography } from '@Components/MuiWrappers/Typography';

const SEOLinkWindow = (props) => {
    return ( 
        <div className='linking-container'>
            {props.IsSearchBySpecs ?
                <h2>{props.InternalLinkGroup.DisplayText}</h2> :
                props.IsHostedSite ?
                <BaseTypography className='' component='h4'>{props.InternalLinkGroup.DisplayText}</BaseTypography> :
                <span className='internal-linking-top'>{props.InternalLinkGroup.DisplayText}</span>}
            < br />   
            <div className='cf'>
                {props.InternalLinkColumns && props.InternalLinkColumns.map(linkColumn =>
                    <div key={linkColumn.ReactKey} className='column3 left'>
                        <ul>
                            {linkColumn.InternalLinks.map(link =>
                                <SEOLink key={link.ReactKey} IsHostedSite={props.IsHostedSite} {...link} />)}
                        </ul>
                    </div>)}
            </div>
        </div>
    );
};

export default SEOLinkWindow;